import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=63372be9&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=63372be9&prod&lang=scss&scoped=true"
import style1 from "./TableList.vue?vue&type=style&index=1&id=63372be9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63372be9",
  null
  
)

export default component.exports